import React, { PureComponent } from 'react'
import { getDisplayName } from 'util/hoc'

export default function withLoadRooms(WrappedComponent) {
  class WithLoadRooms extends PureComponent {
    static displayName = `WithLoadRooms(${getDisplayName(WrappedComponent)})`

    componentDidMount() {
      this.loadRooms()
      this.loadFolderCounts()
    }

    componentDidUpdate(prevProps) {
      if (prevProps.currentQueryId !== this.props.currentQueryId) {
        this.loadRooms()
      }
      this.loadFolderCounts()
    }

    loadRooms = () => {
      const { loadMore, isMatrixReady } = this.props
      if (isMatrixReady) {
        loadMore({ isReload: false })
      } else {
        setTimeout(this.loadRooms, 1000)
      }
    }

    loadFolderCounts = () => {
      if (this.hasLoadedCounts) return
      const {
        queryFilter: { channelId },
        fetchFolderCounts,
      } = this.props
      if (!channelId) return
      this.hasLoadedCounts = true
      fetchFolderCounts({ channelId, channelType: 'widget' })
    }

    render() {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <WrappedComponent {...this.props} />
    }
  }
  return WithLoadRooms
}
